// extracted by mini-css-extract-plugin
module.exports =  {"buttonWrapper":"zf2vJxWWDJcYPTlVPMQ0","link":"UgVqIckAve4bknm7M08A"};